export default {
  companyUrl: 'https://dev.lwtears.com',
  pliUrl: 'https://dev-pli.lwtears.com',
  digitalProductSupportUrl: 'http://localdev.lwtears.com:8081/contact-us/digital-product-support',
  digitalAssetsUrl: 'https://a-z-educator-content-qa.s3.amazonaws.com',
};
